var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcUnLikeOption(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "25px",
    viewBox: "0 0 28 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icUnLikeOption") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.25693272,2.15379834 C3.57735672,0.788180104 5.31346872,0.104445402 7.05193272,0.104445402 C8.79039672,0.104445402 10.5352447,0.788182871 11.8556967,2.15379834 L13.4394327,3.79673952 L15.0231967,2.1624454 C17.6640727,-0.568843652 21.9810853,-0.568782776 24.6219333,2.1624454 C27.2628093,4.89367635 27.2628093,9.28020892 24.6219333,12.0114426 C21.0280493,15.7283221 17.4357887,19.4493521 13.8419327,23.1661485 C13.7361496,23.2766636 13.5890004,23.3392783 13.4350647,23.3392783 C13.2811291,23.3392783 13.1339798,23.2766636 13.0281967,23.1661485 L2.25693272,12.0027817 C-0.380919199,9.269434 -0.383943199,4.88498502 2.25693272,2.15379834 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User-Option--After-actions----Unlike-/-Unfavourite",
    transform: "translate(-28.000000, -397.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Option-popUp",
    transform: "translate(9.000000, 277.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/light-green",
    transform: "translate(19.560000, 120.800000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icUnLikeOption",
    fill: "#7EC34D",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUnLikeOption);
export default __webpack_public_path__ + "static/media/icUnLikeOption.5c3aa181a1b60233cd3d8a371363f3d1.svg";
export { ForwardRef as ReactComponent };